/// <reference path="Main.js" />
/// <reference path="Enumeration-vsdoc.js" />
/// <reference path="Strings-vsdoc.js" />
/// <reference path="fetcher.js"/>

/* global fetcher */
/* exported SetId */

window.JJK = window.JJK || {};

// Begin JJK.AboErmittleDatum *************************************************************************************************
JJK.AboErmittleDatum = function (options) {
	$.extend(this, options);
	$(() => this.init());
};

JJK.AboErmittleDatum.prototype = {
	VonEingegebenId: null,
	VonFormatiertId: null,
	BisFormatiertId: null,
	istNeuesAboShopDesign: false,
	ermittleStartundLetztesVersandDatumUrl: null,
	ermittleStartundLetztesVersandDatumFuerKombiUrl: null,
	ChildAboGewaehltAjaxUrl: null,
	AngezeigtesDatumId: null,
	aktuelleSprache: null,

	init: function () {
		this.istNeuesAboShopDesign = jjk.design.Name === 'TopMenue' || jjk.design.Name === 'VerlagsportaliFrame';
		this.ermittleStartundLetztesVersandDatum();
	},
	getAboTemplateData: function () {
		const aboTemplates = [];
		const templateList = $('.AboListItemForm:visible');
		templateList.each(function () {
			const aboTemplate = $(this).data();
			if (aboTemplate) {
				aboTemplates.push({
					GewaehltesAboTemplateId: aboTemplate.aboTemplateId,
					IstDigitalAbo: aboTemplate.istDigitalAbo,
					AusgabeNr: aboTemplate.ausgabeNr,
					VonEingegeben: $(`#VonEingegeben${aboTemplate.aboTemplateId}`).val(),
					IstKombiAbo: aboTemplate.istKombiAbo,
				});
			}
		});
		return aboTemplates;
	},
	ermittleStartundLetztesVersandDatum: async function () {
		const aboTemplateId = parseInt($('#GewaehltesAboTemplateId').val(), 10);
		const datumId = this.istNeuesAboShopDesign ? this.AngezeigtesDatumId : this.VonEingegebenId;
		const aboAutraegeSubItemListe = this.aboAutraegeSubItemListe.filter(x => x.GewaehltesAboTemplateId === aboTemplateId);
		if (aboAutraegeSubItemListe.length === 0) {
			return;
		}
		const aboAutraegeSubItem = aboAutraegeSubItemListe[0];
		const vonEingegeben = $(`#${datumId}`).val();
		const result = aboAutraegeSubItem.IstKombiAbo
			? [
					await fetcher.postJson(this.ermittleStartundLetztesVersandDatumFuerKombiUrl, {
						GewaehltesAboTemplateId: aboTemplateId,
						GewaehlteAbos: aboAutraegeSubItem.ChildAboTemplateIds,
						VonEingegeben: vonEingegeben,
					}),
				]
			: await fetcher.postJson(this.ermittleStartundLetztesVersandDatumUrl, { AboAutraegeSubItemListe: aboAutraegeSubItemListe });
		$(`#${datumId}`).prop('disabled', true);
		for (let item of result) {
			$(`#${this.VonEingegebenId}`).val(item.VonEingegeben);
			$(`#${datumId}`).val(item.AngezeigtesDatum).attr('data-start-datum', item.StartDatum).attr('data-gueltig-ab', item.GueltigesStartDatumAb);
			this.makeDatePicker(`${this.AngezeigtesDatumId}`, `${item.StartDatum}`);
			$(`#${datumId}`).prop('disabled', false);
		}
	},
	makeDatePicker: function (id, startDate) {
		const datecontrol = new JJK.DateControl({
			id: id,
			sprache: this.aktuelleSprache,
			getMinDate: function () {
				return new Date(startDate);
			},
		});
		return datecontrol;
	},
};

// End JJK.AboErmittleDatum ***************************************************************************************************
